/**
 * N4 멤버 소개 (시안 03 README N4, 이전 S4a 멤버 목록). 하단 탭 없는 하위 화면입니다.
 *
 *   뒤로 + "멤버 소개" → 안내 → 카드 5(초상 56 + 호칭 · 소개 · 담당 + 「1:1」 알약) → 가상 인물 고지
 *
 * - 진입: 별채대화 상단 얼굴 줄 · 대화 선택(☰) 맨 아래 · 나 탭 「멤버 소개」 줄. 뒤로 = 들어온 곳
 * - 카드를 누르면 프로필, 「1:1」을 누르면 바로 대화
 * - 멤버를 '제자'라고 부르지 않습니다. 한 인물에 깊이 빠진 사람으로 소개합니다 (CLAUDE.md)
 */
import { useNavigate } from 'react-router-dom';
import { NotebookPen } from 'lucide-react';
import { MEMBER_KEYS, MEMBERS } from '@config/members/index.js';
import { withJosa } from '@shared/korean.js';
import { Avatar } from '../../components/Avatar.jsx';
import { TopBar } from '../../components/TopBar.jsx';
import { useGoBack } from '../../hooks/useGoBack.js';

export function MembersPage() {
    const navigate = useNavigate();
    const goBack = useGoBack('/');

    return (
        <div className="flex h-dvh flex-col">
            <TopBar title="멤버 소개" onBack={goBack} />
            <main className="flex min-h-0 flex-1 flex-col gap-2.5 overflow-y-auto px-gutter pt-4 pb-[calc(24px+env(safe-area-inset-bottom,0px))]">
                <p className="m-0 mb-1.5 text-[14px] leading-[22px] text-text-secondary">
                    인생상회 별채에 모이는 다섯 사람. 카드를 누르면 프로필을 볼 수 있어요.
                </p>
                <button
                    type="button"
                    onClick={() => navigate('/me/memo?scope=room')}
                    className="flex min-h-12 items-center gap-2 rounded-card border border-hairline bg-surface px-4 text-left text-[14px] font-semibold"
                >
                    <NotebookPen size={18} strokeWidth={1.7} aria-hidden="true" className="text-brand" />
                    멤버 모두 아는 노트
                </button>
                {MEMBER_KEYS.map((memberKey) => {
                    const member = MEMBERS[memberKey];
                    return (
                        <div
                            key={memberKey}
                            className="flex items-center gap-3 rounded-card border border-hairline bg-surface py-3 pr-3 pl-3.5"
                        >
                            <button
                                type="button"
                                onClick={() => navigate(`/members/${memberKey}`, { state: { from: 'members' } })}
                                className="flex min-w-0 flex-1 items-center gap-3 text-left"
                            >
                                <Avatar memberKey={memberKey} size={56} />
                                <span className="flex min-w-0 flex-1 flex-col gap-0.5">
                                    <span className="text-body font-semibold">{member.name}</span>
                                    <span className="text-[13px] leading-[18px]">{member.line}</span>
                                    <span className="text-micro font-normal text-label-muted">{member.short}</span>
                                </span>
                            </button>
                            <div className="flex shrink-0 items-center gap-1.5">
                                <button
                                    type="button"
                                    aria-label={`${member.name}의 노트`}
                                    title={`${member.name}의 노트`}
                                    onClick={() => navigate(`/me/memo?member=${memberKey}`)}
                                    className="flex size-10 items-center justify-center rounded-full border border-hairline text-brand"
                                >
                                    <NotebookPen size={19} strokeWidth={1.7} aria-hidden="true" />
                                </button>
                                <button
                                    type="button"
                                    aria-label={`${withJosa(member.name, '과', '와')} 1:1`}
                                    onClick={() => navigate(`/chat/${memberKey}`, { state: { from: 'members' } })}
                                    className="flex h-10 shrink-0 items-center rounded-[20px] border border-brand px-3 text-[13px] font-semibold text-brand"
                                >
                                    1:1
                                </button>
                            </div>
                        </div>
                    );
                })}
                <span className="mt-2 text-center text-micro font-normal text-label-muted">
                    멤버들은 AI가 연기하는 가상 인물이에요.
                </span>
            </main>
        </div>
    );
}
